// src/redux/slices/documentSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = "https://payyug.in/api";

/* --------------------------------------------------
   Async Thunks
-------------------------------------------------- */

// GET all documents with optional filters
export const fetchDocuments = createAsyncThunk(
  "documents/fetchAll",
  async ({ serviceId, description } = {}, thunkAPI) => {
    try {
      let query = [];

      // Use serviceId passed or fallback to localStorage
      const id = serviceId;
      if (id) query.push(`serviceId=${id}`);

      if (description)
        query.push(`description=${encodeURIComponent(description)}`);

      const queryString = query.length ? `?${query.join("&")}` : "";

      const res = await fetch(`${BASE_URL}/documents${queryString}`);
      if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
      const data = await res.json();
 console.log("data.documents");
console.log(data.documents);
console.log("data.documents");

      return data.documents;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

/* --------------------------------------------------
   Slice
-------------------------------------------------- */

const documentSlice = createSlice({
  name: "documents",
  initialState: {
    documents: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearDocuments: (state) => {
      state.documents = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload;
      })
      .addCase(fetchDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDocuments } = documentSlice.actions;
export default documentSlice.reducer;



